// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    GetUnfilteredProducts,
    ParseQueryParameter,
    PopulateApiParameter,
    chain,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import qs from "qs";

// XNG-Change: add properties to the expand
export const XngPopulateApiParameter = (props: any) => {
    props.apiParameter = {
        ...props.apiParameter,
        expand: [...(props.apiParameter.expand || []), "properties"],
    };
};

export const XngGetUnfilteredProducts: typeof GetUnfilteredProducts = async props => {
    const unfilteredApiParameter = { ...props.apiParameter };
    delete (unfilteredApiParameter as any).isClearanced;
};

export const XngParseQueryParameter: typeof ParseQueryParameter = props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    const { isClearanced } = parsedQuery;

    if (isClearanced !== undefined) {
        (props.result.productFilters as any).isClearanced = true;
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainBefore(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
addToChainAfter(chain, ParseQueryParameter, XngParseQueryParameter);
